import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import { fetchCategories } from './actions';
import CategoryListPage from './categories/CategoryListPage';
import CategoryDetailPage from './categories/CategoryDetailPage';
import SectionDetailPage from './SectionDetailPage';
import EditVideoPage from './video/EditVideoPage';
import Loading from '../common/components/Loading';

class Library extends Component {
  componentDidMount() {
    this.props.dispatch(fetchCategories());
  }

  render() {
    const { loaded, match } = this.props;

    if (!loaded) {
      return <Loading />;
    }

    return (
      <div>
        <Switch>
          <Route exact path={`${match.path}`} component={CategoryListPage} />
          <Route exact path={`${match.path}/:categoryId`} component={CategoryDetailPage} />
          <Route exact path={`${match.path}/:categoryId/sections/:sectionId`} component={SectionDetailPage} />
          <Route
            exact
            path={`${match.path}/:categoryId/sections/:sectionId/videos/:videoId`}
            component={EditVideoPage}
          />
          <Redirect to={`${match.path}`} />
        </Switch>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    loaded: state.library.categories.get('loaded'),
  };
};

export default connect(mapStateToProps)(Library);



// WEBPACK FOOTER //
// ./src/library/Library.js